import { FieldStruct, ImmutableTree, JsonGroup, JsonItem, JsonTree, Utils as QbUtils } from "./awesome";
import { fields } from "./constants/ruleCondField";

export function loadFromTreeForGo(treeForGo: API.TreeForGoNode, newFields) {
	type Queue = {
		node: API.TreeForGoNode;
		jsonTreeFather: JsonGroup | undefined;
	};

	let jsonTree;

	const fieldsMap = getFieldsMap(newFields);

	const queue: Queue[] = [{ node: treeForGo, jsonTreeFather: undefined }];
	let current;
	while ((current = queue.shift())) {
		const { node, jsonTreeFather } = current;

		let jsonTreeNode: JsonItem;
		const id = QbUtils.uuid();
		if (Object.keys(node.left).length === 0) {
			// group
			const nodeGroup = node as API.TreeForGoGroup;
			jsonTreeNode = {
				type: "group",
				children1: {},
				properties: {
					conjunction: nodeGroup.conjunction.toUpperCase()
				}
			};
			nodeGroup.children.forEach(item => queue.push({ node: item, jsonTreeFather: jsonTreeNode as JsonGroup }));
		} else {
			// rule
			const nodeRule = node as API.TreeForGoRule;
			const settingFieldItem = fieldsMap[nodeRule.left.field];
			const valueType = settingFieldItem?.item.type;
			const propertiesField =
				settingFieldItem?.fatherField === undefined
					? nodeRule.left.field
					: `${settingFieldItem.fatherField}.${nodeRule.left.field}`;
			jsonTreeNode = {
				type: "rule",
				properties: {
					field: propertiesField,
					operator: nodeRule.op,
					value: [nodeRule.right],
					valueSrc: ["value"],
					valueType: [valueType]
				}
			};
		}

		if (jsonTreeFather == undefined) {
			jsonTreeNode = jsonTreeNode as JsonGroup;
			jsonTreeNode.id = id;
			jsonTree = jsonTreeNode;
		} else {
			if (jsonTreeFather.children1) {
				jsonTreeFather.children1[id] = jsonTreeNode;
			}
		}
	}
	return QbUtils.loadTree(jsonTree as JsonTree);
}

function getFieldsMap(newFields) {
	// 字段map, 用于TreeForGo转换成ImmutableTree

	const fieldsMap = {};
	/** 修改源组件 */

	if (newFields) {
		Object.keys(newFields).forEach(key => {
			const fieldItem = newFields[key];
			if (fieldItem.type === "!struct") {
				// 分组
				const subFields = (fieldItem as FieldStruct).subfields;
				Object.keys(subFields).forEach(subKey => {
					fieldsMap[subKey] = {
						fatherField: key,
						item: subFields[subKey]
					};
				});
				return;
			}
			fieldsMap[key] = {
				fatherField: undefined,
				item: fieldItem
			};
		});
	} else {
		Object.keys(fields).forEach(key => {
			const fieldItem = fields[key];
			if (fieldItem.type === "!struct") {
				// 分组
				const subFields = (fieldItem as FieldStruct).subfields;
				Object.keys(subFields).forEach(subKey => {
					fieldsMap[subKey] = {
						fatherField: key,
						item: subFields[subKey]
					};
				});
				return;
			}

			console.log("key>>>>>>", {
				fatherField: undefined,
				item: fieldItem
			});
			fieldsMap[key] = {
				fatherField: undefined,
				item: fieldItem
			};
		});
	}

	return fieldsMap;
}

export function convertTreeForGo(immutableTree: ImmutableTree) {
	type Queue = {
		node: JsonTree | JsonItem;
		treeForGoFather: API.TreeForGoGroup | undefined;
	};

	const jsonTree = QbUtils.getTree(immutableTree);

	let treeForGo: API.TreeForGoNode = {
		left: {},
		children: [],
		conjunction: "and"
	};

	const queue: Queue[] = [{ node: jsonTree, treeForGoFather: undefined }];
	let current;
	while ((current = queue.shift())) {
		const { node, treeForGoFather } = current;

		let treeForGoNode: API.TreeForGoNode;

		if (node.type === "group") {
			if (!node.children1) {
				// 缺少必要字段, 异常情况
				continue;
			}
			treeForGoNode = {
				left: {},
				children: [],
				conjunction: node.properties ? node.properties.conjunction.toLowerCase() : "and" // 如果不选择 and or, 默认会不存在conjunction
			};
			Object.values(node.children1).forEach(item => {
				queue.push({
					node: item,
					treeForGoFather: treeForGoNode as API.TreeForGoGroup
				});
			});
		} else if (node.type === "rule") {
			if (!node.properties.field || !node.properties.operator) {
				// 缺少必要字段, 异常情况
				continue;
			}
			treeForGoNode = {
				op: node.properties.operator,
				left: {
					type: "field",
					field: convertCondFieldForGo(node.properties.field)
				},
				right: node.properties.value[0]
			};
		} else {
			continue;
		}

		if (treeForGoFather === undefined) {
			treeForGo = treeForGoNode;
		} else {
			treeForGoFather.children.push(treeForGoNode);
		}
	}
	return treeForGo;
}

export function convertCondFieldForGo(field: string) {
	const fieldScopes = field.split(".");
	return fieldScopes[fieldScopes.length - 1];
}
